import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { ButtonPrimary } from '../../Buttons';

function UnitOccupiedModal({ isOpen, onClose, serialNumber, userEmail }) {
  if (!isOpen) return null;

  const handleSendEmail = () => {
    const subject = `Please Relinquish Unit ${serialNumber}`;
    const body = `Hello, it appears that you are currently occupying unit ${serialNumber}. Please release it as soon as possible.`;
    const mailtoLink = `mailto:${userEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink;
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Background Overlay with Blur */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
        onClick={onClose}
      ></div>

      {/* Modal Content */}
      <div className="bg-foreground p-6 rounded-lg shadow-lg z-10 max-w-lg w-full mx-4">
        <div className="flex flex-row justify-between items-start">
          <h2 className="text-2xl font-semibold text-error mb-4">
            Unit Occupied
          </h2>
          <button
            onClick={onClose}
            className="text-secondary hover:text-primary"
          >
            <i className="fas fa-times"></i> {/* FontAwesome close icon */}
          </button>
        </div>
        <p className="text-secondary mb-6">
          The unit with serial number{' '}
          <span className="font-semibold">{serialNumber}</span> is currently
          occupied by <span className="font-semibold">{userEmail}</span>. As
          such, you will only be able to access this unit in read-only mode.
        </p>
        <ButtonPrimary onClick={handleSendEmail} className={'w-full'}>
          Send Request to Relinquish Unit
        </ButtonPrimary>
      </div>
    </div>
  );
}

export default UnitOccupiedModal;
